import { graphql } from 'react-relay';

export default graphql`
    query favoritesRootQuery(
        $page: Int!
        $userId: String!
        $after: String
        $userIds: [String]!
        $hasUserId: Boolean!
        $first: Int!
        $sortBy: PortfolioItemsSortByTypes
        $foldersSort: PortfoliosSortByTypes
        $searchTerm: String
        $portfolioIds: [String]
        $portfolioTypes: [PortfolioTypes]
        $projectId: String!
        $loadPortfolioData: Boolean!
        $selectedItemIds: [String]!
        $useProjectEndpoint: Boolean!
        $isFolders: Boolean!
        $isFollowing: Boolean!
        $isItems: Boolean!
        $isProjects: Boolean!
        $isSinglePortfolio: Boolean!
        $isTrade: Boolean!
        $itemId: String = ""
        $shouldFetchItem: Boolean = false
        $itemIds: [String]
        $shouldFetchConversation: Boolean = false
        $shouldFetchTransaction: Boolean = false
        $showSeller: Boolean!
        $zipCode: String = ""
        $country: String = ""
        $canCheckZipCode: Boolean = false
        $conversationId: ID = 0
        $hasConversationId: Boolean = false
    ) {
        viewer {
            ...FavoritesContainer_viewer
        }
    }
`;
